import { createFileRoute } from '@tanstack/react-router';

import { ValuationsPage } from '@/features/commercial/valuations-page';

export const Route = createFileRoute('/_app/projects/$projectId/commercial/valuations/')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <ValuationsPage projectId={projectId} />;
}
